export const RateValues = [1, 1.25, 1.5];
